import Checklist from "./controls/Checklist";
import SelectCombobox from "./controls/SelectCombobox";
import DictionaryMultiItems from "./controls/DictionaryMultiItems";
import QuickAddIssue from "./quickAddIssue/QuickAddIssue";
import Notifications from "./notifications/Notifications";
import AvatarEditor from "./avatar/AvatarEditor";
import DatePickers from "./controls/datetime/DatePickers";
import QdMoment from "./controls/Datetime/QdMoment";
import LogDictionaryAutocomplete from "./controls/LogDictionaryAutocomplete";
import IssuesDetails from "./issuesDetails";
import EventForm from "./controls/EventForm";
import SeriousIncident from "./controls/SeriousIncident";
import AuthenticateUser from "./controls/AuthenticateUser";

import 'src/js/common/i18n';
import './utils/ResourceFormat';
import './ajaxWorkflowModal';
import './controls/ColumnFilters';

import LogCompanyTooltipApp from "./controls/LogCompanyTooltipApp";
import Orders from "./controls/Orders";
import Comboboxs from "./controls/Comboboxs";

let getLogPlusResourcesDataControl = () => {
	return import(/* webpackChunkName: "resourcesDataControl" */ './controls/LogPlusResourcesDataControl').then((module) => {
		return module;

	}).catch(error => console.error(error, 'An error occurred while loading the "resourcesDataControl" component'));
}

let getServiceComponent = () => {
	return import(/* webpackChunkName: "serviceRelation" */ './controls/ServiceRelations').then((module) => {
		return module;

	}).catch(error => {
		console.error(error, 'An error occurred while loading the ServiceRelations" component');
	});
}

let getResourcesControlComponent = () => {
	return import(/* webpackChunkName: "resourcesControl" */ './controls/ResourcesControl').then((module) => {
		return module;

	}).catch(error =>
		console.error(error, 'An error occurred while loading the "ResourcesControl" component')
	);
}

(document as any).issueIndexPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "issueIndexPage" */ '../issueIndex/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "issueIndex" component'));
}

(document as any).issueDetailsPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "issueDetailsPage" */ '../issueDetails/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "issueDetails" component'));
}

(document as any).mailRulesPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "mailRulesPage" */ '../mailRules/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "mailRules" component'));
}

(document as any).mailTemplatesPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "mailRulesPage" */ '../emailTemplates/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "emailTemplates" component'));
}

(document as any).userResourcesPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "userResourcesPage" */ '../userResources/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "userResources" component'));
}

(document as any).employeeDetailsViewPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "employeeDetailsViewPage" */ '../employeeDetailsView/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "employeeDetailsViewPage" component'));
}

(document as any).workflowEditorPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "workflowEditorPage" */ '../workflowEditor/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "workflowEditorViewPage" component'));
}

(document as any).workflowFormPageInit = (fn: () => void, isTransient: boolean) => {
	return import(/* webpackChunkName: "workflowFormPageInit" */ './ajaxWorkflowModal/WorkflowFormPage').then((module) => {
		return module.default.init(fn, isTransient);

	}).catch(error => console.error(error, 'An error occurred while loading the "WorkflowFormPage" component'));
}

(document as any).logConfigurationPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "logConfigurationPage" */ '../logConfiguration/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "logConfigurationPage" component'));
}
(document as any).loginsGeneratorConfigurationPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "loginsGeneratorConfigurationPage" */ '../loginsGeneratorConfiguration/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "loginsGeneratorConfigurationPage" component'));
}
(document as any).anonymizationConfigurationPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "anonymizationConfigurationPage" */ '../anonymization/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "anonymizationConfigurationPage" component'));
}
(document as any).mailMsGraphApiConfigurationPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "mailMsGraphApiConfigurationPage" */ '../mailMsGraphApi/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "mailMsGraphApiConfigurationPage" component'));
}

(document as any).goToLogSystemButtonInit = (nodes) => {
	return import(/* webpackChunkName: "goToLogSystemButton" */ './controls/GoToLogSystem').then((module) => {
		return module.default.init(nodes);
	}).catch(error => console.error(error, 'An error occurred while loading the "goToLogSystemButton" component'));
}

function controlsFactoryInit(node) {
	return import(/* webpackChunkName: "controlFactory" */ './controls/ControlFactory').then((module) => {
		return module.default(node);
	}).catch(error => console.error(error, 'An error occurred while loading the "controlFactory" component'));
}

(document as any).servicesConfigurationPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "servicesConfigurationPage" */ '../servicesConfiguration/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "workflowEditorViewPage" component'));
}

(document as any).homePageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "homePage" */ '../home/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "homeViewPage" component'));
}

(document as any).homeAdminPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "homeAdminPage" */ '../homeAdmin/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "homeAdminViewPage" component'));
}

(document as any).editGroupCABPageInit = (fn: () => void) => {
	return import(/* webpackChunkName: "editGroupCABPage" */ '../editGroupCAB/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "editGroupCABPage" component'));
}

(document as any).slaWorkTimesConfigurationInit = (fn: () => void) => {
	return import(/* webpackChunkName: "slaWorkTimesConfigurationPage" */ '../slaTimersConfiguration/app').then((module) => {
		return module.default.init(fn);

	}).catch(error => console.error(error, 'An error occurred while loading the "slaWorkTimesConfigurationPage" component'));
}

(function (qdesk) {
	(function (controls) {

		controls.factory = {
			display: function (className, value, type, mode) {
				let newNode = document.createElement("div");
				newNode.dataset.editor = "False";
				newNode.dataset.className = className;
				newNode.dataset.value = value;
				if (type) newNode.dataset.type = type;
				if (mode) newNode.dataset.mode = mode;
				controlsFactoryInit(newNode);
				return newNode;
			},
			editor: function (className, value, type, type2, mode, field) {
				let newNode = document.createElement("div");
				newNode.dataset.editor = "True";
				newNode.dataset.className = className;
				newNode.dataset.value = value;
				if (type) newNode.dataset.type = type;
				if (type2) newNode.dataset.type2 = type2;
				if (mode) newNode.dataset.mode = mode;
				if (field) newNode.dataset.field = field;
				controlsFactoryInit(newNode);
				return newNode;
			},
		}

		controls.initLogPlusResourcesDataControl = function (id) {
			let control = document.getElementById(id);
			if (!control) {
				return;
			}

			getLogPlusResourcesDataControl().then(module => {
				if (module)
					module.default(control);
			});
		}

		controls.initResourcesControl = function (id) {
			let control = document.getElementById(id) as HTMLDivElement;
			if (!control) {
				return;
			}

			getResourcesControlComponent().then(module => {
				if (module)
					module.default(control);
			});
		}
		
		controls.initServiceRelationControl = function (id) {
			let control = document.getElementById(id);
			if (!control) {
				return;
			}

			getServiceComponent().then(module => {
				if (module)
					module.default(control);
			});
		}

		controls.reload = function (root: HTMLElement, isWorkflow: boolean) {
			var nodes = document.querySelectorAll(Checklist.selector);
			for (let i = 0; i < nodes.length; i++) {
				Checklist.render(nodes[i]); 
			}

			if (!isWorkflow) {
				Comboboxs.reload(root);
			}

			DatePickers.reload();
			SelectCombobox.reload();
			DictionaryMultiItems.reload();
			SeriousIncident.reload();
			AuthenticateUser.reload();
			LogDictionaryAutocomplete.reload();
			EventForm.reload();
			IssuesDetails();
		}

		controls.initSelectCombobox = SelectCombobox.initSelectCombobox;

		controls.avatarEditor = function (btnSelector) {
			var nodes = document.querySelectorAll(btnSelector);
			for (let i = 0; i < nodes.length; i++) {
				nodes[i].addEventListener("click", function() {
					AvatarEditor(this);
				});
			}
		}

		controls.initLogCompanyTooltip = LogCompanyTooltipApp.init;
		controls.initOrdersControl = Orders.init

	})(qdesk.controls = qdesk.controls || {});

})((window as any).qdesk = (window as any).qdesk || {});

(function (qdesk) {
	qdesk.moment = QdMoment();	
})((window as any).qdesk = (window as any).qdesk || {});

document.addEventListener('DOMContentLoaded', function () {
	let isWorkflow = false;
	if (window.location.pathname.startsWith("/Workflow/")) {
		isWorkflow = true;
	}
	(window as any).qdesk.controls.reload(document, isWorkflow);
}, false);

QuickAddIssue();
Notifications();